import * as ActionTypes from '../constants/actionTypes'
import { sellerGetButtonMenu, sellerUpdateButtonMenu } from '../api/seller'

export const editButtonMenuForm = formFieldsChange => ({
  type: ActionTypes.SELLERBUTTONMENUFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.SELLERBUTTONMENUFORM_ENTER_RESET,
})

export const fetchItems = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERBUTTONMENUFORM_FETCHITEMS_LOAD })

  sellerGetButtonMenu(values).then((res) => {
    const items = res.result

    dispatch({
      type: ActionTypes.SELLERBUTTONMENUFORM_FETCHITEMS_SUCCEED,
      items,
    })
    dispatch({
      type: ActionTypes.SELLERBUTTONMENUFORM_EDITFORM_CHANGE,
      fields: items,
      field: {
        idnum: { name: 'idnum', value: items[0].idnum },
        n_enable: { name: 'n_enable', value: !!items[0].n_enable },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERBUTTONMENUFORM_FETCHITEMS_FAIL,
      fetchButtonMenuItemsError: 'Ошибка получения данных элементам меню.',
    })
  })
}

export const editItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERBUTTONMENUFORM_EDITITEM_LOAD })

  sellerUpdateButtonMenu(values).then(() => {
    dispatch({ type: ActionTypes.SELLERBUTTONMENUFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERBUTTONMENUFORM_EDITITEM_FAIL,
      editButtonMenuItemError: 'Ошибка изменения данных.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/sellerButtonMenuForm.js